import engineerAvatar from "@/assets/default-avatars/engineer.png";
import platformAdminAvatar from "@/assets/default-avatars/platform-admin.png";
import smartUserAvatar from "@/assets/default-avatars/smart-user.png";
import tenantAdminAvatar from "@/assets/default-avatars/tenant-admin.png";

type UserLike = Record<string, unknown>;

const EMPTY_AVATAR_VALUES = new Set(["", "null", "undefined"]);

const readText = (value: unknown): string => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

const isValidAvatar = (value: unknown): value is string => {
  const text = readText(value);
  return Boolean(text) && !EMPTY_AVATAR_VALUES.has(text.toLowerCase());
};

export const getDefaultAvatarByUser = (user?: UserLike | null): string => {
  const userType = readText(user?.userType);
  const roleCode = readText(user?.roleCode).toUpperCase();
  const access = readText(user?.access).toLowerCase();
  const roleName = `${readText(user?.roleName)} ${readText(user?.roleNames)} ${readText(
    user?.roleNameCn
  )}`;
  const userName = readText(user?.userName).toLowerCase();

  if (
    userType === "1" ||
    access === "admin" ||
    roleCode.includes("PLATFORM") ||
    roleCode.includes("ADMIN") && !roleCode.includes("TENANT")
  ) {
    return platformAdminAvatar;
  }

  if (userType === "2" || access === "tenant" || roleCode.includes("TENANT")) {
    return tenantAdminAvatar;
  }

  if (
    roleCode.includes("ENGINEER") ||
    roleCode.includes("OPERATOR") ||
    roleName.includes("工程师") ||
    roleName.includes("运维") ||
    userName.includes("engineer")
  ) {
    return engineerAvatar;
  }

  return smartUserAvatar;
};

export const normalizeUserAvatar = <T extends UserLike | null | undefined>(
  user: T
): T => {
  if (!user) return user;

  const avatar = isValidAvatar(user.avatar)
    ? user.avatar
    : isValidAvatar(user.headPic)
    ? user.headPic
    : getDefaultAvatarByUser(user);

  return {
    ...user,
    avatar,
    headPic: avatar,
  } as T;
};
